import RoundStar from '@/icons/round-star';
import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';

interface PDPPlanHighlightTagProps {
  text: string;
  disabled?: boolean;
}

export default function PDPPlanHighlightTag({
  text,
  disabled,
}: PDPPlanHighlightTagProps) {
  return (
    <div
      className={cn('w-fit rounded-br-[15px] rounded-tl-[12px]', {
        'bg-flexcar-neutral100 opacity-50': disabled,
        'bg-none': !disabled,
      })}
    >
      <div className="z-1 flex w-fit items-center gap-[4px] rounded-br-[15px] rounded-tl-[12px] bg-[linear-gradient(90deg,_#7200C0_0.25%,_#2A00A5_99.76%)] py-[4px] pl-[4px] pr-[8px]">
        <RoundStar className="flex-shrink-0" fillPrimary={colors.neutral100} />
        <p className="body3-strong text-flexcar-neutral100">{text}</p>
      </div>
    </div>
  );
}
